import { render, staticRenderFns } from "./FrontPagePreview.vue?vue&type=template&id=7891a7b6&"
import script from "./FrontPagePreview.vue?vue&type=script&lang=js&"
export * from "./FrontPagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports